module.exports = __webpack_public_path__ + "media/components/riskregister/icon-vectors/project-09cd96b66606570f4ffa2c2bcc00f9a8.png";